import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cab40daa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  value: "",
  disabled: ""
}
const _hoisted_2 = ["value", "selected"]
const _hoisted_3 = {
  key: 5,
  class: "form-control borderless ps-0"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "me-3" }, " Yes ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " No ", -1))
const _hoisted_6 = {
  key: 9,
  class: "currency-wrap"
}
const _hoisted_7 = {
  key: 0,
  class: "currency-code"
}
const _hoisted_8 = {
  key: 1,
  class: "currency-code"
}
const _hoisted_9 = {
  key: 10,
  class: "d-flex flex-row align-items-center position-relative"
}
const _hoisted_10 = { class: "position-absolute translate-middle-y top-50 end-0 me-5" }
const _hoisted_11 = {
  key: 11,
  class: "d-flex w-100 flex-row align-items-center position-relative"
}
const _hoisted_12 = {
  key: 12,
  class: "d-flex flex-row align-items-center position-relative"
}
const _hoisted_13 = {
  key: 13,
  class: "d-flex w-100 flex-row align-items-center position-relative input-group"
}
const _hoisted_14 = {
  key: 14,
  class: "form-group"
}
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = { class: "input-group-append" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _directive_maska = _resolveDirective("maska")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.colClass)
  }, [
    (_ctx.showLabel)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass(_ctx.labelClass)
        }, _toDisplayString(_ctx.fieldLabel), 3))
      : _createCommentVNode("", true),
    (_ctx.multiselectFieldType)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Field, {
            class: "d-none",
            type: "text",
            "data-type": "select",
            name: _ctx.name
          }, null, 8, ["name"]),
          _createVNode(_component_Multiselect, {
            closeOnSelect: true,
            name: _ctx.name,
            options: _ctx.options,
            placeholder: _ctx.selectFieldPlaceholder,
            required: _ctx.required,
            searchable: _ctx.searchable,
            value: _ctx.name,
            label: _ctx.optionLabel,
            trackBy: _ctx.optionLabel,
            valueProp: _ctx.optionValue,
            disabled: _ctx.disabled,
            onChange: _ctx.handleSelectChange,
            onClose: _ctx.handleSelectCloseOrClose,
            onDeselect: _ctx.handleSelectCloseOrClose,
            ref: "multiselect"
          }, null, 8, ["name", "options", "placeholder", "required", "searchable", "value", "label", "trackBy", "valueProp", "disabled", "onChange", "onClose", "onDeselect"])
        ], 64))
      : (_ctx.multipleSelectionTag)
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 2,
            modelValue: _ctx.fieldValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fieldValue) = $event)),
            multiple: "",
            "collapse-tags": "",
            placeholder: "Select",
            class: "w-100",
            required: _ctx.required,
            disabled: _ctx.disabled
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, key) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: key,
                  label: item,
                  value: item
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "required", "disabled"]))
        : (_ctx.selectFieldType)
          ? (_openBlock(), _createBlock(_component_Field, {
              key: 3,
              class: _normalizeClass(_ctx.formControlClass),
              name: _ctx.name,
              as: "select",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleSelectChange($event.target.value)))
            }, {
              default: _withCtx(({ value }) => [
                _createElementVNode("option", _hoisted_1, _toDisplayString(_ctx.optionLabel), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: option.value,
                    value: option.value,
                    selected: value && value.includes(option.value)
                  }, _toDisplayString(option.label), 9, _hoisted_2))
                }), 128))
              ]),
              _: 1
            }, 8, ["class", "name"]))
          : (_ctx.fileFieldType)
            ? (_openBlock(), _createBlock(_component_Field, {
                key: 4,
                onChange: _ctx.handleFileUpload,
                accept: _ctx.accepts,
                autocomplete: _ctx.autocomplete,
                name: _ctx.name,
                placeholder: _ctx.fieldPlaceholder,
                type: _ctx.type,
                class: _normalizeClass(_ctx.formControlClass)
              }, null, 8, ["onChange", "accept", "autocomplete", "name", "placeholder", "type", "class"]))
            : (_ctx.radioButtonFieldType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_Field, {
                    name: _ctx.name,
                    value: _ctx.useBoolValue ? true : 'Yes',
                    class: "me-1",
                    type: "radio"
                  }, null, 8, ["name", "value"]),
                  _hoisted_4,
                  _createVNode(_component_Field, {
                    name: _ctx.name,
                    value: _ctx.useBoolValue ? false : 'No',
                    class: "me-1",
                    type: "radio"
                  }, null, 8, ["name", "value"]),
                  _hoisted_5
                ]))
              : (_ctx.textareaFieldType)
                ? (_openBlock(), _createBlock(_component_Field, {
                    key: 6,
                    autocomplete: _ctx.autocomplete,
                    disabled: _ctx.disabled,
                    name: _ctx.name,
                    placeholder: _ctx.fieldPlaceholder,
                    as: "textarea",
                    class: "form-control overflow-visible",
                    "data-kt-autosize": "true",
                    rows: "3"
                  }, null, 8, ["autocomplete", "disabled", "name", "placeholder"]))
                : (_ctx.numberFieldType)
                  ? (_openBlock(), _createBlock(_component_Field, {
                      key: 7,
                      disabled: _ctx.disabled,
                      name: _ctx.name,
                      placeholder: _ctx.fieldPlaceholder,
                      class: _normalizeClass(_ctx.formControlClass),
                      pattern: "^\\d*(\\.\\d{0,2})?$",
                      step: "1",
                      type: "number",
                      onChange: _ctx.checkForDecimalPlaces
                    }, null, 8, ["disabled", "name", "placeholder", "class", "onChange"]))
                  : (_ctx.maskFieldType)
                    ? _withDirectives((_openBlock(), _createBlock(_component_Field, {
                        key: 8,
                        disabled: _ctx.disabled,
                        name: _ctx.name,
                        placeholder: _ctx.fieldPlaceholder,
                        class: _normalizeClass(_ctx.formControlClass),
                        type: "text"
                      }, null, 8, ["disabled", "name", "placeholder", "class"])), [
                        [_directive_maska, _ctx.mask]
                      ])
                    : (_ctx.currencyFieldType)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_ctx.currency === 'dollar')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "$"))
                            : _createCommentVNode("", true),
                          (_ctx.currency === 'peso')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "₱"))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Field, {
                            name: _ctx.name,
                            placeholder: _ctx.fieldPlaceholder,
                            class: _normalizeClass(_ctx.formControlClass),
                            type: "text"
                          }, null, 8, ["name", "placeholder", "class"])
                        ]))
                      : (_ctx.passwordFieldType)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_Field, {
                              autocomplete: _ctx.autocomplete,
                              disabled: _ctx.disabled,
                              name: _ctx.name,
                              placeholder: _ctx.fieldPlaceholder,
                              type: _ctx.showPassword ? 'text' : 'password',
                              class: _normalizeClass(_ctx.formControlClass),
                              ref: "password"
                            }, null, 8, ["autocomplete", "disabled", "name", "placeholder", "type", "class"]),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("i", {
                                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setShowPassword && _ctx.setShowPassword(...args))),
                                class: _normalizeClass(["bi bi bi-eye-fill h-25px fs-3 cursor-pointer", _ctx.showPassword ? 'bi-eye-slash-fill' : 'bi-eye-fill'])
                              }, null, 2)
                            ])
                          ]))
                        : (_ctx.datePickerType)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_Field, {
                                autocomplete: _ctx.autocomplete,
                                disabled: _ctx.disabled,
                                name: _ctx.name
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_component_el_date_picker, _mergeProps({
                                    class: "w-100",
                                    type: "date"
                                  }, field, {
                                    modelValue: field.value,
                                    "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                    format: _ctx.dateFormat,
                                    "value-format": _ctx.dateValueFormat,
                                    placeholder: _ctx.fieldPlaceholder,
                                    "disabled-date": _ctx.disabledDates,
                                    onChange: _ctx.handleChange
                                  }), null, 16, ["modelValue", "onUpdate:modelValue", "format", "value-format", "placeholder", "disabled-date", "onChange"])
                                ]),
                                _: 1
                              }, 8, ["autocomplete", "disabled", "name"])
                            ]))
                          : (_ctx.dateRangeType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(_component_Field, {
                                  autocomplete: _ctx.autocomplete,
                                  disabled: _ctx.disabled,
                                  name: _ctx.name,
                                  type: "daterange"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_el_date_picker, _mergeProps({ type: "daterange" }, field, {
                                      "range-separator": _ctx.rangeSeparator,
                                      "start-placeholder": _ctx.startPlaceholder,
                                      "end-placeholder": _ctx.endPlaceholder,
                                      format: _ctx.dateFormat
                                    }), null, 16, ["range-separator", "start-placeholder", "end-placeholder", "format"])
                                  ]),
                                  _: 1
                                }, 8, ["autocomplete", "disabled", "name"])
                              ]))
                            : (_ctx.colorPickerFieldType)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_Field, {
                                    autocomplete: _ctx.autocomplete,
                                    disabled: _ctx.disabled,
                                    name: _ctx.name,
                                    type: "colorpicker"
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(_component_el_color_picker, {
                                        "model-value": field.value,
                                        "color-format": "hex",
                                        class: "color-picker-custom w-100",
                                        onChange: _ctx.handleColorPickerChange,
                                        onActiveChange: _ctx.handleColorPickerActiveChange
                                      }, null, 8, ["model-value", "onChange", "onActiveChange"])
                                    ]),
                                    _: 1
                                  }, 8, ["autocomplete", "disabled", "name"])
                                ]))
                              : (_ctx.inputGroupType)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                      _withDirectives(_createVNode(_component_Field, {
                                        autocomplete: _ctx.autocomplete,
                                        disabled: _ctx.disabled,
                                        name: _ctx.name,
                                        placeholder: _ctx.fieldPlaceholder,
                                        type: _ctx.type,
                                        class: _normalizeClass(_ctx.formControlClass)
                                      }, null, 8, ["autocomplete", "disabled", "name", "placeholder", "type", "class"]), [
                                        [_directive_mask, _ctx.mask]
                                      ]),
                                      _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("button", {
                                          class: "btn btn-primary",
                                          type: "button",
                                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)))
                                        }, _toDisplayString(_ctx.buttonTitle), 1)
                                      ])
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 15 }, [
                                    (_ctx.mask)
                                      ? _withDirectives((_openBlock(), _createBlock(_component_Field, {
                                          key: 0,
                                          autocomplete: _ctx.autocomplete,
                                          disabled: _ctx.disabled,
                                          name: _ctx.name,
                                          placeholder: _ctx.fieldPlaceholder,
                                          type: _ctx.type,
                                          class: _normalizeClass(_ctx.formControlClass)
                                        }, null, 8, ["autocomplete", "disabled", "name", "placeholder", "type", "class"])), [
                                          [_directive_mask, _ctx.mask]
                                        ])
                                      : (_openBlock(), _createBlock(_component_Field, {
                                          key: 1,
                                          autocomplete: _ctx.autocomplete,
                                          disabled: _ctx.disabled,
                                          name: _ctx.name,
                                          placeholder: _ctx.fieldPlaceholder,
                                          type: _ctx.type,
                                          onBlur: _ctx.handleBlur,
                                          onInput: _ctx.handleInput,
                                          onKeyup: _ctx.handleKeyup,
                                          class: _normalizeClass(_ctx.formControlClass)
                                        }, null, 8, ["autocomplete", "disabled", "name", "placeholder", "type", "onBlur", "onInput", "onKeyup", "class"]))
                                  ], 64)),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_ErrorMessage, { name: _ctx.name }, null, 8, ["name"])
      ])
    ]),
    (_ctx.slot)
      ? _renderSlot(_ctx.$slots, "default", { key: 16 }, undefined, true)
      : _createCommentVNode("", true)
  ], 2))
}